import * as React from "react";

import { useOneTimePasswordSendCodeForm } from "../../providers";

import {
  OneTimePasswordVerifyCodeFormUi,
  OneTimePasswordVerifyCodeFormUiProps,
} from "../../one-time-password";

export interface StepVerifyCodeProps {
  useInitialState: OneTimePasswordVerifyCodeFormUiProps["useInitialState"];
}
export const StepVerifyCode: React.FunctionComponent<StepVerifyCodeProps> = (
  props
) => {
  const { form } = useOneTimePasswordSendCodeForm();
  return (
    <section className="bbnt-common-join-drawer-fragment one-time-password-step step-verify-code">
      <img className="rewards-fancy-title-image" alt="REWARDS" />
      <h1 className="main-drawer-title">{`Enter your one-time code`}</h1>
      <p className="helpful-receive-code-shortly-subtitle">
        {`If the email is registered with us, you will receive a code shortly at `}
        <span className="users-email">{`${form.email || ""}`}</span>
        {`. Enter it below (the code will expire after 5 minutes).`}
      </p>

      <OneTimePasswordVerifyCodeFormUi
        useInitialState={props.useInitialState}
      />
    </section>
  );
};
